export default "__VITE_ASSET__V7wYE17G__"